import AdminLayout from '@/components/admin/AdminLayout';
import { AppWrapper } from '@/components/AppWrapper';
import { store } from '@/redux/store';
import '@/styles/index.css';
import type { NextPage } from 'next';
import type { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import type { ReactElement, ReactNode } from 'react';
import { useEffect } from 'react';

export type NextPageWithLayout<P = Record<string, never>, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

const MyApp = ({ Component, pageProps }: AppPropsWithLayout): JSX.Element => {
  const router = useRouter();
  const project = store.getState().project.data;

  const isAdminRoute = router.pathname.startsWith('/adminx');

  let title = '';
  if (isAdminRoute) {
    title = 'MINERVA Admin';
  } else if (project) {
    title = project.name;
  }

  useEffect(() => {
    document.title = title;
  }, [title]);

  const getLayout = Component.getLayout ?? ((page: ReactElement): ReactNode => page);

  return (
    <AppWrapper>
      {isAdminRoute ? (
        <AdminLayout>{getLayout(<Component {...pageProps} />)}</AdminLayout>
      ) : (
        getLayout(<Component {...pageProps} />)
      )}
    </AppWrapper>
  );
};

export default MyApp;
